import {APP_BASE_HREF, CommonModule} from '@angular/common';
import {Component, Inject, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WiseIdAuthServiceManager } from '../../controller/wise-id-auth.service-manager';
import { UserService } from "@rfebm/sso-api";
import { UserResult } from '@rfebm/sso-api';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-after-login',
  templateUrl: 'after-login.component.html',
  styleUrls: ['after-login.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class AfterLoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private wiseIdAuthServiceManager: WiseIdAuthServiceManager,
    private userService: UserService,
    @Inject(APP_BASE_HREF) private baseHref: string
  ) { }

  async ngOnInit() {
    let redirect: string = 'login'
    try {
      const queryParams = this.route.snapshot.queryParams; // Get authorization code from query parameters
      const code = queryParams['code'];
      await this.wiseIdAuthServiceManager.loginWithWiseId(code);  // Get access token using the authorization code


      redirect = 'home';
    } catch (error) {
      console.error('Sesion expired or not logged in, redirecting to login page.', error);
      redirect = 'login'
    }

    window.location.href = this.baseHref + redirect;

  }

}
